module.exports = __webpack_public_path__ + "img/rglite.0c709515.png";